import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { FC, useLayoutEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { Base, Footer, Header, Loading, Toast } from './components';
import { IndicacaoPage } from './pages/indicacao';
import { PublicHomePage } from "./pages/public-home";
import Router from './Router';
import { handleLogin, isCadastroPublicoRoute, isPublicRoute } from './services/session';
import { clearSession } from './services/session/loginService';
import { getUserById } from './services/user';
import { useUserStore } from './stores';
import { useAuthStore } from './stores/auth-store';
import { MainTheme } from './theme';
import { muiTheme } from "./theme/muiTheme";

const App: FC = () => {
	const { setUser } = useUserStore();
	const { isAuthenticated, setAuthenticated } = useAuthStore();
	const [loading, setLoading] = useState(true);

	useLayoutEffect(() => {
		const fetchData = async (id: string) => {
			const data = await getUserById({ id});

			if (!data) {
				clearSession();
				setAuthenticated(false);
				return;
			}

			setUser(data);
		};

		const sid = handleLogin();

		if (sid) {
			// handleLogin pode ter restaurado a sessao persistida ("Manter-me conectado")
			// depois que a auth-store calculou seu estado inicial — sincroniza aqui.
			setAuthenticated(true);
			fetchData(sid).finally(() => setLoading(false));
		} else {
			setLoading(false);
		}
	}, [setUser, setAuthenticated]);


	if (loading) return <Loading fullScreen />;

	const showPublicAuthShell =
		isCadastroPublicoRoute() || (!isAuthenticated && !isPublicRoute());

	if (showPublicAuthShell) {
		return (
			<MuiThemeProvider theme={muiTheme}>
				<StyledThemeProvider theme={MainTheme}>
					<BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
						<Toast />
						<Routes>
							<Route path='/cadastro' element={<IndicacaoPage />} />
							<Route path='/login' element={<PublicHomePage />} />
							<Route path='*' element={<Navigate to='/login' replace />} />
						</Routes>
					</BrowserRouter>
				</StyledThemeProvider>
			</MuiThemeProvider>
		);
	}

	return (
		<MuiThemeProvider theme={muiTheme}>
			<StyledThemeProvider theme={MainTheme}>
				<BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
					<Toast />
					<Routes>
						<Route
							path='*'
							element={
								<>
									<Header />
									<Base>
										<Router />
									</Base>
									<Footer />
								</>
							}
						/>
					</Routes>
				</BrowserRouter>
			</StyledThemeProvider>
		</MuiThemeProvider>
	);
};

export default App;
